export default {
    subscriptions: [],
    infoDB: {}
}